import { DateField, DateFieldProps } from "react-admin";

const CustomDateField = (props: DateFieldProps) => {
  return <DateField locales={"FR-fr"} {...props} />;
};

export default CustomDateField;
